import { cancelTypeService } from '../../helpers/services/cancelType.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const CANCEL_TYPE_MODULE = 'cancelType';

// define action 
export const GET_ALL_CANCEL_TYPES = 'getAllcancelTypes';
export const GET_CANCEL_TYPE = 'getcancelType';
export const UPDATE_CANCEL_TYPE = 'updatecancelType';
export const CREATE_CANCEL_TYPE = 'createcancelType';
export const UPDATE_CANCEL_TYPE_STATUS = 'updatecancelTypeStatus';

// define mutation
const SUCCESS = "commonSuccess";
const SUCCESS_WITHOUT_REDIRECT = "successWithoutRedirect";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_CANCEL_TYPES_REQUEST = "getAllcancelTypes";
const GET_CANCEL_TYPE_REQUEST = "getcancelType";

export const actions = {
    // eslint-disable-next-line no-unused-vars
     [GET_ALL_CANCEL_TYPES]({ commit }, { filter }) {
         cancelTypeService
            .getAllcancelTypes(filter)
            .then(
                (result) => {
                    commit(GET_ALL_CANCEL_TYPES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
     [GET_CANCEL_TYPE]({ commit }, { id }) {
        cancelTypeService
            .getcancelType(id)
            .then(
                (result) => {
                    commit(GET_CANCEL_TYPE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CANCEL_TYPE]({ commit }, { data }) {
        commit(REQUEST)
        cancelTypeService
            .updatecancelType(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.cancelType')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_CANCEL_TYPE]: async ({ commit }, { redirect, data }) => {
        commit(REQUEST);
        var return_result = [];
        try {
            var result = await cancelTypeService.createcancelType(data);
            return_result['type_uuid'] = result.data.uuid;
            const message = i18n.t("message.createXSuccess", [i18n.t('module.cancelType')]);
            sharedHelper.alertSuccessMessage(message);

            if (redirect) {
                commit(SUCCESS);
            } else {
                commit(SUCCESS_WITHOUT_REDIRECT);
            }

            return_result['result'] = true

        } catch (error) {
            const message = sharedHelper.getErrorMessage(error);
            sharedHelper.alertErrorMessage(message, error.response?.data?.code);
            commit(FAILURE);
            return_result['result'] = false
        }

        return return_result;

    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CANCEL_TYPE_STATUS]({ dispatch }, { filter, data }) {
        cancelTypeService
            .updatecancelTypeStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_CANCEL_TYPES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },


};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Cancel-types-listing" });
    },
    [SUCCESS_WITHOUT_REDIRECT](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_CANCEL_TYPES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                is_charge_money: o.is_charge_money,
                is_refund_money: o.is_refund_money,
                isActive: o.is_active,
                createdBy: o.created_by,
                image: o.image,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
                
            }
        })
    },
    [GET_CANCEL_TYPE_REQUEST](state, data) {
        let o = data.data
        
        state.details = {
            uuid: o.uuid,
            name: o.name,
            is_charge_money: o.is_charge_money,
            is_refund_money: o.is_refund_money,
            isActive: o.is_active,
            createdBy: o.created_by,
            image: o.image,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }
    }
}


